// v3/shared/components/RumPageTracker.tsx — Records normalized page views to CloudWatch RUM
// Replaces built-in auto page views (which use raw URLs with PII) with normalized page IDs.
// User attribution is handled via session attributes (set in useLogin.ts after authentication).
// Zero imports from v1/v2.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getRumClient, normalizePagePath } from '../../../shared/rum';

/**
 * Records every route change as a RUM page view with normalized path.
 * No PII (phone numbers, app IDs) reaches CloudWatch RUM.
 * User identification comes from session attributes set at login.
 */
export function RumPageTracker() {
  const location = useLocation();

  useEffect(() => {
    try {
      getRumClient()?.recordPageView(normalizePagePath(location.pathname));
    } catch { /* ignore */ }
  }, [location.pathname]);

  return null;
}
